import ModalHtml from '@/components/ModalHtml'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: ModalHtml,
		html: dom.innerHTML.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
	}

	let page = vuewidget(dom, options)
	return page
}
